import { API_BASE } from '../config';
import { projectApi } from './projectApi';

/**
 * 音频服务 REST 封装：后端 /api/audio/*（AudioService，grsai 平台）
 * TTS 返回 wav base64，转录返回纯文本
 */

export async function synthesizeSpeech(
    text: string,
    voiceName: string = 'Puck',
    referenceAudioBase64?: string,
): Promise<string> {
    const resp = await fetch(`${API_BASE}/api/audio/tts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            text,
            voice_name: voiceName,
            reference_audio_base64: referenceAudioBase64 || undefined,
        }),
    });
    if (!resp.ok) {
        const detail = await resp.json().catch(() => null);
        throw new Error(detail?.detail || `TTS failed: HTTP ${resp.status}`);
    }
    const data = await resp.json();
    if (!data.audioData) throw new Error('未收到生成的音频');
    return `data:${data.mimeType || 'audio/wav'};base64,${data.audioData}`;
}

export async function transcribeAudio(audioBase64: string): Promise<string> {
    const resp = await fetch(`${API_BASE}/api/audio/transcribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ audio_base64: audioBase64 }),
    });
    if (!resp.ok) {
        const detail = await resp.json().catch(() => null);
        throw new Error(detail?.detail || `Transcription failed: HTTP ${resp.status}`);
    }
    const data = await resp.json();
    return data.text || '';
}

export async function uploadAudioAsset(
    projectId: string,
    audioDataUrl: string,
    nodeId: string,
    prompt: string,
): Promise<string> {
    const blob = await (await fetch(audioDataUrl)).blob();
    const file = new File([blob], `audio_${nodeId}_${Date.now()}.wav`, { type: blob.type || 'audio/wav' });
    const asset = await projectApi.uploadAsset(projectId, file, {
        generator_node_id: nodeId,
        generator_type: 'audio',
        prompt,
    });
    return asset.url;
}
